<div class="m-1" [class.invalid]="invalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label [for]="effectiveControlId()" class="form-label">
            {{ label() }}
            @if (isRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }

    <div class="input-group">
        <input
            #dateInput
            [id]="effectiveControlId()"
            class="form-control shadow-sm"
            [placeholder]="placeholder()"
            [formControl]="inputControl"
            [class.is-invalid]="invalid()"
            ngbDatepicker
            [maxDate]="$any(maxDate())"
            [minDate]="$any(minDate())"
            #picker="ngbDatepicker"
            (dateSelect)="valueChanged($event)"
            readonly="true"
            container="body"
        />
        <button class="btn btn-outline-secondary" (click)="picker.toggle()" type="button" [disabled]="effectivelyDisabled()">
            <fa-icon [icon]="['fas', 'calendar']"></fa-icon>
        </button>
    </div>
</div>
